<template>
  <div class="placeholder">
    <div class="placeholder-icon">
      <span class="icon">
        <i class="fa fa-wrapper fa-sync fa-spin"></i>
      </span>
    </div>
    <h6 class="placeholder-title">{{ title }}</h6>
    <div class="placeholder-subtitle">
      Hang tight, we won't be long: just waiting to get your data from the
      server.
    </div>
  </div>
</template>
<script>
module.exports = {
  name: "placeholder",
  props: ["title"]
};
</script>
